<template>

    <div class="my-questionnaire-list-badge"
         v-if="loaded && uncompletedSurveyCount > 0">

        <b-badge variant="danger" class="float-right number-badge">
            {{ uncompletedSurveyCount }}
        </b-badge>

    </div>

</template>

<!-- ----------------------------------------------------------------------- -->

<script>
    import Vue from 'vue'
    import * as _ from 'lodash'

    /**
     * Badge showing the number of uncompleted invited surveys
     */
    export default Vue.extend({
        name: 'MyQuestionnaireListBadge',
        computed: {
            participant () {
                return this.$store.state.patientParticipant
            },
            loaded () {
                return !!this.participant && !!this.participant.id && !!this.participant.latestSurveys
            },
            uncompletedSurveyCount () {
                const uncompleted = _.filter(this.participant.latestSurveys, (survey) => {
                    return !!survey.survey_id && !survey.is_complete
                })
                return uncompleted.length
            }
        },
    })
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

    .my-questionnaire-list-badge {
        .badge {
            border-radius: 50%;
            padding: 8px 10px;
        }
    }

</style>
